var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Search/IsolateButton.tsx";
import { ToggleSwitch } from '@gmini/ui-kit';
import { goals } from "../../metrika";
import { Wrapper } from "./IsolateButton.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IsolateButton = function IsolateButton(_ref) {
  var isolated = _ref.isolated,
      isolate = _ref.isolate;
  return /*#__PURE__*/_jsxs(Wrapper, {
    onClick: function onClick() {
      goals.selectViewerModeTransparent();
      isolate(!isolated);
    },
    children: [/*#__PURE__*/_jsx(ToggleSwitch, {
      size: "smedium",
      active: isolated,
      color: "#4C5ECF"
    }), "\u0418\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C"]
  });
};